// extracted by mini-css-extract-plugin
module.exports = {"overlay":"BaseModal_overlay__3EQLn","modal":"BaseModal_modal__1v5gV","small":"BaseModal_small__38IIM","header":"BaseModal_header__LBik_","closeIcon":"BaseModal_closeIcon__Ljy-o"};